import {CommonModule} from "@angular/common";
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from "@angular/core";
import {TabsModule} from "ngx-bootstrap/tabs";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {RouterModule} from "@angular/router";
import {KalemHttpInterceptor} from "../shared/services/kalem.interceptor";
import {SharedModule} from "../shared/shared.module";
import {ManagementModule} from "@dashboard/modules/management/management.module";
import {MyTabComponent} from "./components/partials/my-tab/my-tab.component";
import {PanelComponent} from "./components/partials/panel/panel.component";
import {MyTabsComponent} from "./components/partials/my-tabs/my-tabs.component";
import {HeaderComponent} from "./components/partials/header/header.component";
import {MainComponent} from "./components/main/main.component";
import {SpeCodeListComponent} from "@dashboard/modules/application-params/specode/components/specode-list/specode-list.component";
import {SpeCodeFormComponent} from "@dashboard/modules/application-params/specode/components/specode-form/specode-form.component";
import {VatGroupsListComponent} from "@dashboard/modules/application-params/vat-group/components/vat-groups-list/vat-groups-list.component";
import {VatGroupFormComponent} from "@dashboard/modules/application-params/vat-group/components/vat-group-form/vat-group-form.component";
import {CurrencyComponent} from "@dashboard/components/currency/currency.component";
import {ApplicationParamsModule} from "@dashboard/modules/application-params/application-params.module";
import {ApiService} from "@app/modules/shared/services/base/api.service";
import {KlDyModalComponent} from "./components/partials/modal/modal.component";
import {UserFormComponent} from "@dashboard/modules/management/user/components/user-form/user-form.component";
import {UserListComponent} from "@dashboard/modules/management/user/components/user-list/user-list.component";
import {RoleListComponent} from "@dashboard/modules/management/role/components/role-list/role-list.component";
import {RoleFormComponent} from "@dashboard/modules/management/role/components/role-form/role-form.component";
import {ProfileComponent} from "./components/profile/profile.component";
import {SidebarComponent} from "./components/partials/sidebar/sidebar.component";
import {KlModalComponent} from "@app/modules/dashboard/components/kl-modal/kl-modal.component";
import {KlFastMaterialEntryComponent} from "@app/modules/shared/components/fast-material-entry/fast-material-entry.component";
import {KlAlertComponent} from "@app/modules/shared/components/alert/kl-alert.component";
import {KlPreferenceSaveFormComponent} from "@app/modules/shared/components/preference-form/kl-preference-save-form.component";
import {KlMenuComponent} from "./components/partials/kl-menu/kl-menu.component";
import {DynamicFormComponent} from "../shared/components/dynamic-form/dynamic-form.component";
import {MaterialListComponent} from "@dashboard/modules/material-management/material/components/material-list/material-list.component";
import {MaterialFormComponent} from "@dashboard/modules/material-management/material/components/material-form/material-form.component";
import {UnitListComponent} from "@dashboard/modules/material-management/unit/components/unit-list/units-list.component";
import {UnitFormComponent} from "@dashboard/modules/material-management/unit/components/unit-form/unit-form.component";
import {UnitSetListComponent} from "@dashboard/modules/material-management/unit-set/components/unit-set-list/unit-set-list.component";
import {UnitSetFormComponent} from "@dashboard/modules/material-management/unit-set/components/unit-set-form/unit-set-form.component";
import {MaterialDetailFilterComponent} from "@dashboard/modules/material-management/material/components/material-detail-filter/material-detail-filter.component";
import {MaterialManagementModule} from "@dashboard/modules/material-management/material-management.module";
import {SidebarModule} from "primeng/sidebar";
import {KlReportFilterComponent} from "@app/modules/shared/components/kl-report-filter/kl-report-filter.component";
import {CurrentAccountListComponent} from "@dashboard/modules/finance-management/current-account/components/current-account-list/current-account-list.component";
import {CurrentAccountFormComponent} from "@dashboard/modules/finance-management/current-account/components/current-account-form/current-account-form.component";
import {ShippingAddressListComponent} from "@dashboard/modules/finance-management/shipping-address/components/shipping-address-list/shipping-address-list.component";
import {ShippingAddressFormComponent} from "@dashboard/modules/finance-management/shipping-address/components/shipping-address-form/shipping-address-form.component";
import {CurrentAccountDetailFilterComponent} from "@dashboard/modules/finance-management/current-account/components/current-account-detail-filter/current-account-detail-filter.component";
import {FinanceManagementModule} from "@dashboard/modules/finance-management/finance-management.module";
import {BulkMaterialImportComponent} from "@dashboard/components/bulk-material-import/bulk-material-import.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TabsHoverComponent} from "./components/partials/my-tabs/tabs-hover/tabs-hover.component";
import {KlConfirmDialogComponent} from "@app/modules/shared/components/kl-confirm-dialog/kl-confirm-dialog.component";
import {TaxareaListComponent} from "@dashboard/modules/application-params/taxarea/components/taxarea-list/taxarea-list.component";
import {SectorFormComponent} from "@dashboard/modules/management/sector/components/sector-form/sector-form.component";
import {VatRateListComponent} from "@dashboard/modules/application-params/vat-rate/components/vat-rate-list/vat-rate-list.component";
import {VatRateFormComponent} from "@dashboard/modules/application-params/vat-rate/components/vat-rate-form/vat-rate-form.component";
import {NumberSchemaListComponent} from "@dashboard/modules/application-params/number-schema/components/number-schema-list/number-schema-list.component";
import {NumberSchemaFormComponent} from "@dashboard/modules/application-params/number-schema/components/number-schema-form/number-schema-form.component";
import {ShippingManagementModule} from "@dashboard/modules/shipping-management/shipping-management.module";
import {CustomerFormComponent} from "@dashboard/modules/shipping-management/customer/components/customer-form/customer-form.component";
import {CustomerListComponent} from "@dashboard/modules/shipping-management/customer/components/customer-list/customer-list.component";
import {SectorListComponent} from "@dashboard/modules/management/sector/components/sector-list/sector-list.component";
import {EmailSettingsComponent} from "@dashboard/modules/management/email/components/email-settings/email-settings.component";
import {VirtualOrderReceiptListComponent} from "@dashboard/modules/shipping-management/virtual-order-receipt/components/virtual-order-receipt-list/virtual-order-receipt-list.component";
import {VirtualOrderReceiptFormComponent} from "@dashboard/modules/shipping-management/virtual-order-receipt/components/virtual-order-receipt-form/virtual-order-receipt-form.component";
import {ProductLicenseFormComponent} from "@dashboard/modules/material-management/product-license/components/product-license-form/product-license-form.component";
import {ProductLicenseListComponent} from "@dashboard/modules/material-management/product-license/components/product-license-list/product-license-list.component";
import {ProductLicenseDetailFilterComponent} from "@dashboard/modules/material-management/product-license/components/product-license-detail-filter/product-license-detail-filter.component";
import {InstallationUserListComponent} from "@dashboard/modules/management/installation-user/components/installation-user-list/installation-user-list.component";
import {InstallationUserFormComponent} from "@dashboard/modules/management/installation-user/components/installation-user-form/installation-user-form.component";
import {RolePermissionComponent} from "@dashboard/modules/management/role/components/role-permission/role-permission.component";
import {VirtualOrderReceiptDetailFilterComponent} from "@dashboard/modules/shipping-management/virtual-order-receipt/components/virtual-order-receipt-detail-filter/virtual-order-receipt-detail-filter.component";
import {CustomerDetailFilterComponent} from "@dashboard/modules/shipping-management/customer/components/customer-detail-filter/customer-detail-filter.component";
import {TreeViewModule} from "@syncfusion/ej2-angular-navigations";
import {ButtonModule} from "primeng/button";
import {CollapseModule} from "ngx-bootstrap/collapse";
import {AutoCompleteModule} from "primeng/autocomplete";
import {OtherOperationsModule} from "@dashboard/modules/other-operations/other-operations.module";
import {EmqGetPasswordFormComponent} from "@dashboard/modules/other-operations/emq-get-password/emq-get-password-form/emq-get-password-form.component";
import {FooterComponent} from "./components/partials/footer/footer.component";
import {ProductLicenseHistoryComponent} from "@dashboard/modules/material-management/product-license/components/product-license-history/product-license-history.component";
import {LicenseDocumentsReportComponent} from "./modules/material-management/reports/license-documents-report/license-documents-report.component";
import {
  LemInfoListComponent
} from "@dashboard/modules/other-operations/lem-info/list/lem-info-list/lem-info-list.component";
import {
  LemInfoFormComponent
} from "@dashboard/modules/other-operations/lem-info/form/lem-info-form/lem-info-form.component";

const _entryComponents = [
  MyTabComponent,
  SpeCodeListComponent,
  SpeCodeFormComponent,
  VatGroupsListComponent,
  VatGroupFormComponent,
  MaterialListComponent,
  MaterialFormComponent,
  MaterialDetailFilterComponent,
  LicenseDocumentsReportComponent,
  UnitListComponent,
  UnitFormComponent,
  UnitSetListComponent,
  UnitSetFormComponent,
  CurrentAccountListComponent,
  CurrentAccountFormComponent,
  ShippingAddressListComponent,
  ShippingAddressFormComponent,
  KlDyModalComponent,
  RoleListComponent,
  RoleFormComponent,
  UserListComponent,
  UserFormComponent,
  ProfileComponent,
  KlFastMaterialEntryComponent,
  KlAlertComponent,
  KlPreferenceSaveFormComponent,
  KlMenuComponent,
  DynamicFormComponent,
  KlAlertComponent,
  CurrentAccountDetailFilterComponent,
  KlReportFilterComponent,
  BulkMaterialImportComponent,
  KlConfirmDialogComponent,
  TaxareaListComponent,
  SectorFormComponent,
  VatRateListComponent,
  VatRateFormComponent,
  NumberSchemaListComponent,
  NumberSchemaFormComponent,
  CustomerFormComponent,
  CustomerListComponent,
  CurrencyComponent,
  SectorListComponent,
  SectorFormComponent,
  EmailSettingsComponent,
  VirtualOrderReceiptListComponent,
  VirtualOrderReceiptFormComponent,
  ProductLicenseFormComponent,
  ProductLicenseListComponent,
  ProductLicenseDetailFilterComponent,
  InstallationUserListComponent,
  InstallationUserFormComponent,
  RolePermissionComponent,
  VirtualOrderReceiptDetailFilterComponent,
  CustomerDetailFilterComponent,
  EmqGetPasswordFormComponent,
  ProductLicenseHistoryComponent,
    LemInfoListComponent,
    LemInfoFormComponent
];

@NgModule({
  declarations: [
    MainComponent,
    MyTabComponent,
    HeaderComponent,
    PanelComponent,
    MyTabsComponent,
    CurrencyComponent,
    KlModalComponent,
    KlDyModalComponent,
    ProfileComponent,
    SidebarComponent,
    KlMenuComponent,
    BulkMaterialImportComponent,
    TabsHoverComponent,
    CurrencyComponent,
    FooterComponent,
  ],
  entryComponents: _entryComponents,
  imports: [
    CommonModule,
    SidebarModule,
    ManagementModule,
    ApplicationParamsModule,
    FinanceManagementModule,
    MaterialManagementModule,
    ShippingManagementModule,
    OtherOperationsModule,
    TabsModule.forRoot(),
    RouterModule.forChild([
      {
        path: "",
        component: MainComponent,
      },
    ]),
    TreeViewModule,
    AutoCompleteModule,
    HttpClientModule,
    SharedModule.forRoot(),
    CollapseModule.forRoot(),
    ButtonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [MyTabsComponent, BulkMaterialImportComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KalemHttpInterceptor,
      multi: true,
    },
    MyTabsComponent,
    ApiService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [MainComponent],
})
export class DashboardModule {}
